import useStyles from "./VendorDetail.css";
import translation from "../../../i18n/i18.json";
import { Grid, Tab, Tabs } from "@material-ui/core";
import { ExtendCompnayData } from "../../../models/VendorRequestChange/VendorRequestChangeData";
import { useEffect, useState } from "react";

interface ExtendDataProp {
  extendList: ExtendCompnayData[];
}

export default function ExtendData(props: ExtendDataProp) {
  const initialCompanyState: ExtendCompnayData = {
      coCode: "",
      poCode: [],
      reconACCode: "",
      paymentMethodCode: [],
      houseBankCode: "",
      creditPeriodDays: "",
      orderCurrency: "",
      alternativeCurrency: [],
      termsOfTrade: "",
      permittedPayeeList: [],
      houseBank: ""
    };
  const classes = useStyles();
  const { extendList } = props;
  const [selectedCompnayExtend, setSelectedExtendCompnay] = useState<ExtendCompnayData>(initialCompanyState);

  useEffect(() => {
    setSelectedExtendCompnay(extendList && extendList.length > 0 ? extendList[0] : initialCompanyState);
  }
  , []);

  const concateDataList = (datalist: any) => {
    if (datalist && datalist.length > 0) {
      let concatstring = datalist.join(",");
      return concatstring;
    }
    return "";
  };

  const onTabsChange = (event: React.ChangeEvent<{}>, coCode: string) => {
    if (selectedCompnayExtend.coCode != coCode) {
      let selected = extendList.find(v => v.coCode == coCode);
      setSelectedExtendCompnay(selected ? selected : initialCompanyState);
    }
  };

  return (
    <div>
      <Grid container spacing={2} item xs={12} sm={12} md={12} lg={12} className={classes.formOneWrapper}>
        <Grid container spacing={2} item xs={12} sm={12} md={12} lg={12} >
          <Tabs value={selectedCompnayExtend.coCode || ''} onChange={onTabsChange}>
            {extendList.map((et) => (
              <Tab label={et.coCode} value={et.coCode} />
              ))}
          </Tabs>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={4}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendorchangepopup_co_lbl}
            </span>
          </Grid>
          <Grid className={classes.formOneinputWrapper} item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.textWrap}>{selectedCompnayExtend.coCode}</span>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={4}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendorchangepopup_po_lbl}
            </span>
          </Grid>
          <Grid className={classes.formOneinputWrapper} item xs={12} sm={12} md={12} lg={12} >
            <span className={classes.textWrap}>
              {concateDataList(selectedCompnayExtend.poCode)}
            </span>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={4}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendorchangepopup_recon_lbl}
            </span>
          </Grid>
          <Grid className={classes.formOneinputWrapper} item xs={12} sm={12} md={12} lg={12} >
            <span className={classes.textWrap}>
              {selectedCompnayExtend.reconACCode}
            </span>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={4}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendorchangepopup_payment_lbl}
            </span>
          </Grid>
          <Grid className={classes.formOneinputWrapper} item xs={12} sm={12} md={12} lg={12} >
            <span className={classes.textWrap}>
              {selectedCompnayExtend.paymentMethodCode}
            </span>
          </Grid>
        </Grid>   
        <Grid item xs={12} sm={12} md={6} lg={4}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendor_detail_paymentdetails_permittedpayee_lbl}
            </span>
          </Grid>
          <Grid className={classes.formOneinputWrapper} item xs={12} sm={12} md={12} lg={12} >
            <span className={classes.textWrap}>
              {concateDataList(selectedCompnayExtend.permittedPayeeList)}
            </span>
          </Grid>
        </Grid>    
        <Grid item xs={12} sm={12} md={6} lg={4}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendorchangepopup_housebank_lbl}
            </span>
          </Grid>
          <Grid className={classes.formOneinputWrapper} item xs={12} sm={12} md={12} lg={12} >
            <span className={classes.textWrap}>
              {selectedCompnayExtend.houseBank}
            </span>
          </Grid>
        </Grid>  
        <Grid item xs={12} sm={12} md={6} lg={4}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendorchangepopup_creaditperd_lbl}
            </span>
          </Grid>
          <Grid className={classes.formOneinputWrapper} item xs={12} sm={12} md={12} lg={12} >
            <span className={classes.textWrap}>
              {selectedCompnayExtend.creditPeriodDays}
            </span>
          </Grid>
        </Grid> 
        <Grid item xs={12} sm={12} md={6} lg={4}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendorchangepopup_ordercrncy_lbl}
            </span>
          </Grid>
          <Grid className={classes.formOneinputWrapper} item xs={12} sm={12} md={12} lg={12} >
            <span className={classes.textWrap}>
              {selectedCompnayExtend.orderCurrency}
            </span>
          </Grid>
        </Grid>  
        <Grid item xs={12} sm={12} md={6} lg={4}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendorchangepopup_settlementcrncy_lbl}
            </span>
          </Grid>
          <Grid className={classes.formOneinputWrapper} item xs={12} sm={12} md={12} lg={12} >
            <span className={classes.textWrap}>
              {concateDataList(selectedCompnayExtend.alternativeCurrency)}
            </span>
          </Grid>
        </Grid>  
        <Grid item xs={12} sm={12} md={6} lg={4}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <span className={classes.formTwoLbl}>
              {translation.vendorchangepopup_termstra_lbl}
            </span>
          </Grid>
          <Grid className={classes.formOneinputWrapper} item xs={12} sm={12} md={12} lg={12} >
            <span className={classes.textWrap}>
              {selectedCompnayExtend.termsOfTrade}
            </span>
          </Grid>
        </Grid>  
      </Grid>
    </div>
  );
}
